// extracted by mini-css-extract-plugin
export default {"portfolioSelector":"Portfolio_portfolioSelector__gHmRX","advisor":"Portfolio_advisor__5lIYG","container":"Portfolio_container__tut8p"};